import { MockService } from '../../../core/services/mock.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable, map, delay, catchError, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Response } from '../models/stock-summary-master.model';

@Injectable({
  providedIn: 'root',
})
export class WHInvBookkeepingService {
  // 測試範例為了模擬資料查詢時間，實際開發不會用到
  delay: number = 500;

  constructor(
    private readonly mockService: MockService,
    private readonly httpClient: HttpClient
  ) { }

  getWHInvBookkeeping(queryCondition: any = {}): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/wh-inv-bookkeeping/search`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/wh-inv-bookkeeping-search.json'
    );

    if (environment.apiMock) {
      return this.httpClient.get<Response>(endpoint).pipe(
        map((data) => data),
        delay(this.delay)
      );
    }
    return this.httpClient.post<Response>(endpoint, queryCondition);
  }

  getWHInvBookkeepingResult(queryCondition: any = {}): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/search-batch/query`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/wh-inv-bookkeeping-search-result.json'
    );

    if (environment.apiMock) {
      return this.httpClient.get<Response>(endpoint).pipe(
        map((data) => data),
        delay(this.delay)
      );
    }

    return this.httpClient.post<Response>(endpoint, queryCondition).pipe(
      map((data) => data),
      delay(this.delay)
    );
  }

  getWHInvBookkeepingDetail(queryCondition: any = {}): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/wh-inv-bookkeeping/detail`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/wh-inv-bookkeeping.json'
    );

    if (environment.apiMock) {
      return this.httpClient.get<Response>(endpoint).pipe(
        map((data) => data),
        delay(this.delay)
      );
    }

    return this.httpClient.get<Response>(endpoint, {
      params: queryCondition
    }).pipe(
      delay(this.delay)
    );
  }
}
